module.exports = __webpack_public_path__ + "img/designavator1.cd0e9254.jpg";